




























import Vue from "vue";
import { mapGetters, mapActions, mapMutations } from "vuex";

export default Vue.extend({
  name: "SendNotifyModal",
  data() {
    return {
      key: "value",
      type: "all",
      sending: false
    };
  },
  computed: {
    ...mapGetters({
      sendItemModal: "notify/sendItemModal"
    })
  },
  methods: {
    ...mapMutations({
      setSendModal: "notify/setSendModal"
    }),
    ...mapActions({
      sendNotifyAtc: "notify/sendNotify"
    }),
    async sendNotify() {
      this.sending = true;
      try {
        await this.sendNotifyAtc({
          title: "Thông báo mới",
          body: this.sendItemModal.title,
          notifyId: this.sendItemModal._id,
          option: this.type
        });
        this.sending = false;
      } catch (error) {
        this.sending = false;
        console.log(error);
      }
    },
    handleCancel() {
      this.setSendModal({ show: false });
    }
  }
});
